export default __webpack_public_path__ + "static/k8s-attr-diag-16fa70ee3a4efeb4f6f19c4f55f452ac.png";